import { mutationFor, queryFor } from "@visioni/a3s-client-api/app";
import { listSitesEndpoint } from "../client-messages";
import { updateSiteEndpoint } from "../client-messages";

export const listSitesQuery = queryFor(listSitesEndpoint);
export const updateSiteMutation = mutationFor(updateSiteEndpoint);
